import { useSlotRecipe } from '@chakra-ui/react';

import {
    BreadCrumbs,
    generateBreadcrumbSchema,
} from '@nocowanie/common-ui/components/molecules/breadcrumbs';

import { environment } from '@app/environments/environment';

import { ListingBreadcrumbsProps } from './listing-breadcrumbs.props';

export const ListingBreadcrumbs = ({ breadcrumbs, name }: ListingBreadcrumbsProps) => {
    const recipe = useSlotRecipe({ key: 'listingLayout' });
    const styles = recipe({});
    const schemaObj = generateBreadcrumbSchema(breadcrumbs, name, environment.NOCOWANIE_URL);

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaObj) }}
            />
            <BreadCrumbs
                breadcrumbs={breadcrumbs}
                name={name}
                baseUrl={environment.NOCOWANIE_URL}
                css={styles.breadcrumbs}
            />
        </>
    );
};
